import { ITraceableError } from '@/interfaces/Error';

export interface IErrorsState {
  errors: ITraceableError[];
}

export default {
  errors: new Array<ITraceableError>(),
} as IErrorsState;